export default "__VITE_ASSET__BCynTlXQ__"